import {
  ButtonGroup,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  Stack,
  Tooltip,
  Typography,
  Fade,
  Popper,
  useTheme,
  PopperPlacementType,
} from 'src/components/mui';
//@ts-ignore
import React from 'react';
import { useState } from 'react';
import ThemeConfig from 'src/theme';
import { Icon } from '../icon/Icon';

type View = {
  icon: string;
  iconType?: string;
  label: string;
  active?: boolean;
  onClick?: () => void;
};

type Props = {
  items: View[];
  popper?: View[];
  poperLabel?: string;
  popperPlacement?: PopperPlacementType;
};

function ViewPillContent({ items, popper, poperLabel, popperPlacement = 'top-end' }: Props) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { palette } = useTheme();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? 'transition-popper' : undefined;

  const showPopper = items.length > 3;

  return (
    <>
      <ButtonGroup
        variant="contained"
        sx={{
          height: '36px',
          overflow: 'hidden',
          borderRadius: '15px',
          background: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(15px)',
        }}
      >
        {items.slice(0, 3).map((v) => (
          <Tooltip key={v.label} title={v.label} enterDelay={1000} arrow>
            <IconButton onClick={v.onClick || handleClick} sx={{ height: '36px', width: '36px' }}>
              <Icon
                icon={v.icon}
                type={v.iconType}
                sx={{ ...(v.active ? { color: palette.treedis.cyan.main } : {}) }}
                fontSize="18px"
              />
            </IconButton>
          </Tooltip>
        ))}
        {showPopper && (
          <IconButton onClick={handleClick} sx={{ height: '36px', width: '36px' }}>
            <Icon
              type="fa-sharp"
              icon="fa-caret-down"
              fontSize="18px"
              sx={{
                transform: open ? 'rotate(180deg)' : undefined,
                transition: 'all .3s',
              }}
            />
          </IconButton>
        )}
      </ButtonGroup>

      {((popper && popper?.length > 0) || showPopper) && (
        <Popper id={id} open={open} anchorEl={anchorEl} transition placement={popperPlacement}>
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <List
                disablePadding
                sx={{
                  mb: '10px',
                  pb: 1,
                  background: 'rgba(0, 0, 0, 0.5)',
                  backdropFilter: 'blur(15px)',
                  color: 'white',
                  position: 'relative',
                  borderRadius: '15px',
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  paddingLeft={2}
                  paddingRight={1}
                  paddingY={1}
                >
                  <Typography variant="body2">{poperLabel || 'Content'}</Typography>
                  <IconButton onClick={() => setOpen(false)} size="small">
                    <Icon icon="fa-times" size="small" />
                  </IconButton>
                </Stack>
                {(popper || items.slice(3)).map((v) => (
                  <ListItem
                    key={v.label}
                    disablePadding
                    onClick={() => {
                      if (v.onClick) {
                        v.onClick();
                      }
                      setOpen(false);
                    }}
                  >
                    <ListItemButton>
                      <Icon
                        icon={v.icon}
                        type={v.iconType}
                        sx={{ ...(v.active ? { color: palette.treedis.cyan.main } : {}) }}
                        fontSize="18px"
                      />
                      <Typography sx={{ ml: 1, fontSize: '16px' }}>{v.label}</Typography>
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Fade>
          )}
        </Popper>
      )}
    </>
  );
}

export function ViewPill(props: Props) {
  return (
    <ThemeConfig>
      <ViewPillContent {...props} />
    </ThemeConfig>
  );
}
